import React from "react";
import logo from "../assets/img/logo.png";
import "../assets/css/main.css";

class Header extends React.Component {
  render() {
    return (
      <header className="">
        <article>
          <div className="container-fluid">
            <div className="row">
              {/* <div className="col-12"> */}
              <div className="col-6 text-left">
                <a href="https://www.constellation.com/">
                  <img src={logo} alt="Logo" className="headerImg img-fluid" />
                </a>
              </div>
              <div className="col-6">
                <div className="text-right">
                  <nav
                    className="visible-lg-inline-block list-unstyled list-inline"
                    // role="navigation"
                  >
                    <div className="text component">
                      <ul>
                        <li className="contact">
                          <a href="https://www.constellation.com/about-us/contact-us">
                            Contact Us
                          </a>
                        </li>
                        <li className="contact">
                          <a href="https://my.constellation.com">
                            My Constellation
                          </a>
                        </li>
                      </ul>
                    </div>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </article>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/common/header.jsx